import React from "react";
import { useNavigate } from "react-router-dom";

import Selo from "../comum/Selo";
import Tabela from "../comum/Tabela";
import { data, dataHora, pct, reais } from "../comum/formato";
import { rotaCupom } from "../rotas";

export function disponibilidade(c) {
  if (!c.existe) return "Cupom excluído";
  const partes = [];
  if (c.valido_de || c.valido_ate) partes.push(`${c.valido_de ? data(c.valido_de) : "sempre"} → ${c.valido_ate ? data(c.valido_ate) : "sem fim"}`);
  else partes.push("Sem prazo");
  if (c.dias_semana?.length) partes.push(c.dias_semana.join(", "));
  if (c.horario) partes.push(c.horario);
  return partes.join(" · ");
}

export default function TabelaCupons({ cupons, query }) {
  const navigate = useNavigate();
  const colunas = [
    { id: "codigo", rotulo: "Cupom", valor: (c) => c.codigo, render: (c) => (
      <div className="min-w-0">
        <p className="font-bold font-mono tracking-wide">{c.codigo}</p>
        <p className="text-[11px] text-muted-foreground">{c.valor_rotulo} · {c.categoria_rotulo}</p>
      </div>) },
    { id: "status", rotulo: "Status", valor: (c) => c.status, render: (c) => <Selo status={c.status} rotulo={c.status_rotulo} /> },
    { id: "disp", rotulo: "Disponível", render: (c) => <span className="text-xs text-muted-foreground">{disponibilidade(c)}</span>, classe: "max-w-[14rem]" },
    { id: "pedidos", rotulo: "Pedidos", alinhar: "direita", valor: (c) => c.pedidos, render: (c) => <b>{c.pedidos}</b> },
    { id: "desconto", rotulo: "Desconto", alinhar: "direita", valor: (c) => c.desconto, render: (c) => <span className="text-amber-600 dark:text-amber-400">{reais(c.desconto)}</span> },
    { id: "faturado", rotulo: "Faturado", alinhar: "direita", valor: (c) => c.faturado, render: (c) => reais(c.faturado) },
    { id: "ticket", rotulo: "Ticket", alinhar: "direita", valor: (c) => c.ticket_medio, render: (c) => (c.pedidos ? reais(c.ticket_medio) : "—") },
    { id: "lucro", rotulo: "Lucro", alinhar: "direita", valor: (c) => c.lucro, render: (c) => (c.lucro == null ? <span className="text-muted-foreground">—</span> : (
      <span className={c.lucro < 0 ? "text-red-500" : "text-emerald-600 dark:text-emerald-400"}>{reais(c.lucro)}<span className="block text-[10px] text-muted-foreground">{pct(c.margem_pct)}</span></span>)) },
    { id: "novos", rotulo: "Clientes novos", alinhar: "direita", valor: (c) => c.clientes_novos, render: (c) => c.clientes_novos || "—" },
    { id: "ultimo", rotulo: "Último uso", alinhar: "direita", valor: (c) => c.ultimo_uso || "", render: (c) => <span className="text-xs">{c.ultimo_uso ? dataHora(c.ultimo_uso) : "—"}</span> },
  ];
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <div className="flex items-baseline justify-between gap-2 mb-2">
        <h3 className="font-semibold">Cupons</h3>
        <span className="text-xs text-muted-foreground">Clique num cupom pra ver o relatório dele</span>
      </div>
      <Tabela colunas={colunas} linhas={cupons} chave={(c) => c.chave} e2e="tabela-cupons"
        onClicar={(c) => navigate(`${rotaCupom(c.chave)}${query}`)} vazio="Nenhum cupom com esses filtros." />
    </section>
  );
}
